import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { languages, translations } from '../utils/translations';

export default function About() {
  const { lang } = useParams();
  const navigate = useNavigate();
  const currentLang = lang && translations[lang] ? lang : 'en';
  const t = translations[currentLang];

  const switchLang = (code) => {
    navigate(code === 'en' ? '/about' : `/about/${code}`);
  };

  return (
    <div className="min-h-screen bg-[#030405] text-white font-mono">
      {/* Header */}
      <header
        className="w-full h-16 flex items-center px-6"
        style={{
          background: 'rgba(6,9,14,0.92)',
          borderBottom: '1px solid rgba(0,240,255,0.12)',
          backdropFilter: 'blur(20px)',
        }}
      >
        <div className="flex items-center gap-3">
          <div className="flex gap-[3px]">
            <div className="w-[3px] h-5" style={{ background: '#00F0FF', boxShadow: '0 0 8px #00F0FF' }} />
            <div className="w-[3px] h-5 opacity-50" style={{ background: '#00F0FF' }} />
            <div className="w-[3px] h-5 opacity-25" style={{ background: '#00F0FF' }} />
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-white leading-none">Boobs Works</div>
            <div className="text-[8px] uppercase tracking-[0.25em] text-[#00F0FF]/50 mt-0.5">3D bust generator</div>
          </div>
        </div>
        <nav className="ml-auto flex items-center gap-6">
          <Link
            to="/"
            className="text-[9px] uppercase tracking-[0.2em] text-gray-400 hover:text-[#00F0FF] transition-colors"
          >
            {t.generator}
          </Link>
          <span className="text-[9px] uppercase tracking-[0.2em] text-[#00F0FF]">{t.about}</span>
        </nav>
      </header>

      {/* Language Switcher */}
      <div
        className="w-full px-6 py-3 flex flex-wrap gap-2 items-center"
        style={{ borderBottom: '1px solid rgba(0,240,255,0.07)', background: 'rgba(6,9,14,0.7)' }}
      >
        <span className="text-[8px] uppercase tracking-[0.25em] text-gray-600 mr-2">Lang:</span>
        {languages.map((l) => (
          <button
            key={l.code}
            onClick={() => switchLang(l.code)}
            className={`px-2.5 py-1 text-[9px] tracking-wide border transition-all duration-150 ${
              currentLang === l.code
                ? 'border-[#00F0FF]/60 text-[#00F0FF] bg-[#00F0FF]/8'
                : 'border-gray-800 text-gray-500 hover:border-gray-600 hover:text-gray-300'
            }`}
            style={currentLang === l.code ? { boxShadow: '0 0 8px rgba(0,240,255,0.12)' } : {}}
          >
            {l.name}
          </button>
        ))}
      </div>

      {/* Content */}
      <main
        className="max-w-2xl mx-auto px-6 py-16"
        dir={currentLang === 'ar' ? 'rtl' : 'ltr'}
      >
        <div className="mb-2 text-[9px] uppercase tracking-[0.3em] text-[#00F0FF]/60">{t.about}</div>
        <h1 className="text-3xl font-mono font-semibold tracking-tight text-white mb-6">
          {t.title}
        </h1>

        <p className="text-sm leading-7 text-gray-400 mb-8">
          {t.intro}
        </p>

        <div
          className="mb-10 p-px"
          style={{ background: 'linear-gradient(135deg, rgba(0,240,255,0.2), transparent)' }}
        >
          <div className="bg-[#06090e] p-6">
            <h2 className="text-[10px] uppercase tracking-[0.3em] text-[#00F0FF] mb-4">{t.featuresTitle}</h2>
            <ul className="space-y-3 text-sm text-gray-400">
              {t.features.map((f, i) => (
                <li key={i} className="flex gap-3">
                  <span className="text-[#00F0FF]/60 shrink-0">—</span>
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mb-10">
          <h2 className="text-[10px] uppercase tracking-[0.3em] text-[#00F0FF] mb-4">{t.useCasesTitle}</h2>
          <p className="text-sm leading-7 text-gray-400">
            {t.useCasesText}
          </p>
        </div>

        <div className="mb-10">
          <h2 className="text-[10px] uppercase tracking-[0.3em] text-[#00F0FF] mb-4">{t.howItWorksTitle}</h2>
          <p className="text-sm leading-7 text-gray-400">
            {t.howItWorksText}
          </p>
        </div>

        <div className="pt-8 border-t border-[#00F0FF]/10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-[9px] uppercase tracking-[0.25em] border border-[#00F0FF]/40 text-[#00F0FF] hover:bg-[#00F0FF]/10 transition-colors"
          >
            {t.back}
          </Link>
        </div>
      </main>
    </div>
  );
}
